import { FC } from 'react';
import { graphql } from '../../../../../gql';
import { useApiQuery } from '../../../../../query/hooks';
import { AddItemSelect } from '../../components/AddItemSelect';
import { useIntl } from 'react-intl';
import { useModalContext } from '../../../../../modal/ModalContext';

const opportunitySelect_listOpportunities = graphql(`
	query opportunitySelect_listOpportunities {
		listOpportunity(filter: { status: { notEq: resolved } }) {
			id
			name
		}
	}
`);

type AddOpportunitySelectProps = Readonly<{
	removedIds?: string[];
	onChange: (value: string) => void;
	activityId: string;
}>;

export const AddOpportunitySelect: FC<AddOpportunitySelectProps> = ({ removedIds, onChange, activityId }) => {
	const intl = useIntl();
	const { setModal } = useModalContext();
	const { isLoading, data } = useApiQuery(opportunitySelect_listOpportunities);
	const options = (data?.listOpportunity ?? [])
		.filter((o) => !removedIds || !removedIds.includes(o.id))
		.map((o) => ({ label: o.name, id: o.id }));

	const handleCreateOpportunity = (): void => {
		setModal({
			type: 'createOpportunityAndAddToActivity',
			payload: {
				activityId,
			},
		});
	};

	return (
		<AddItemSelect
			text={intl.formatMessage({ id: 'journey.detail.widget.opportunities.add' })}
			noItemsText={intl.formatMessage({ id: 'journey.detail.widget.opportunities.no-opportunities' })}
			createText={intl.formatMessage({ id: 'journey.detail.widget.opportunities.create' })}
			isLoading={isLoading}
			options={options}
			onChange={onChange}
			onCreate={handleCreateOpportunity}
		/>
	);
};
